export function mapRealEstateError(code: string): string {
  switch (code) {
    case "HAS_CHILDREN":
      return "realestate.errors.has_children";
    case "HAS_PREPAYMENTS":
      return "realestate.errors.has_prepayments";
    case "INVALID_ACCOUNT":
      return "realestate.errors.invalid_account";
    case "INVALID_LOAN":
      return "realestate.errors.invalid_loan";
    case "VALIDATION_ERROR":
      return "realestate.errors.validation";
    case "NOT_FOUND":
      return "realestate.errors.not_found";
    case "AUTHENTICATION_ERROR":
      return "errors.unauthenticated";
    case "INVALID_TENANCY":
      return "realestate.errors.invalid_tenancy";
    case "MISSING_INITIAL_RENT":
      return "realestate.errors.missing_initial_rent";
    case "LAST_RENT_CHANGE":
      return "realestate.errors.last_rent_change";
    case "INVALID_RENT_CHANGE":
      return "realestate.errors.invalid_rent_change";
    case "EMPTY_OVERRIDE":
      return "realestate.errors.empty_override";
    case "INVALID_OVERRIDE_MONTH":
      return "realestate.errors.invalid_override_month";
    case "INVALID_OVERRIDE_VALUE":
      return "realestate.errors.invalid_override_value";
    default:
      return "errors.unknown";
  }
}
